var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "cargo-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          ref: "cargoDialog",
          staticClass: "bill-payment-apply-dialog",
          attrs: {
            title: _vm.title,
            visible: _vm.innerVisible,
            "can-maximize": _vm.dynamics,
            "can-minimize": _vm.dynamics,
            width: _vm.dashboardUrl ? "960px" : "760px"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            },
            close: _vm.handleClose
          }
        },
        [
          _c("div", [
            _c("h1", [_vm._v(_vm._s(_vm.workflowTitle))]),
            _c(
              "table",
              {
                staticClass: "details-table",
                attrs: { cellpadding: "0", cellspacing: "0" }
              },
              [
                !_vm.isApply
                  ? _c("tr", [
                      _c("td", { staticClass: "header" }, [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_ApprovalSerialNumber"))
                        )
                      ]),
                      _c("td", { staticClass: "values" }, [
                        _vm._v(_vm._s(_vm.processInfo.documentProcessNo))
                      ]),
                      _c("td", { staticClass: "header" }, [
                        _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_StartDate")))
                      ]),
                      _c("td", { staticClass: "values" }, [
                        _vm._v(_vm._s(_vm.processInfo.createDate))
                      ])
                    ])
                  : _vm._e(),
                _c("tr", [
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Applicant")))
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(
                      _vm._s(
                        _vm.ColumnUtils.resolveColumnLabel(
                          _vm.TYPE_NAMES.basic_data_User,
                          "userId",
                          _vm.billPayment.inputBy,
                          "chineseName"
                        )
                      )
                    )
                  ]),
                  _c("td", { staticClass: "header" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_InitiateBranchCompany"))
                    )
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(
                      _vm._s(
                        _vm.ColumnUtils.resolveColumnLabel(
                          _vm.TYPE_NAMES.basic_data_Office,
                          "officeId",
                          _vm.billPayment.branchId,
                          "chineseName"
                        )
                      )
                    )
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "header" }, [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_PaymentApplicationNo"))
                    )
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(_vm._s(_vm.billPayment.billPaymentNo))
                  ]),
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BusinessType")))
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(_vm._s(_vm.lobLabel()))
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SettlementCompany")))
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(
                      _vm._s(
                        _vm.ColumnUtils.resolveColumnLabel(
                          _vm.TYPE_NAMES.basic_data_Company,
                          "cmpIdx",
                          _vm.billPayment.accountId,
                          "chineseName"
                        )
                      )
                    )
                  ]),
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PaymentMethod")))
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(_vm._s(_vm.paymentMethodLabel()) + " ")
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Amount")))
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: "values",
                      staticStyle: { "font-size": "14px", color: "red" }
                    },
                    [_vm._v(_vm._s(_vm.billPaymentAmount))]
                  ),
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Currency")))
                  ]),
                  _c(
                    "td",
                    {
                      staticClass: "values",
                      staticStyle: { "font-size": "14px", color: "red" }
                    },
                    [_vm._v(_vm._s(_vm.billPayment.currency))]
                  )
                ]),
                _c("tr", [
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PaymentPeriod")))
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(_vm._s(_vm.dateLabel(_vm.billPayment.deadline)))
                  ]),
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Remarks")))
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(_vm._s(_vm.billPayment.remark))
                  ])
                ]),
                _c("tr", [
                  _c("td", { staticClass: "header" }, [
                    _vm._v(_vm._s(_vm.$t("Partners.paymentType")))
                  ]),
                  _c("td", { staticClass: "values" }, [
                    _vm._v(
                      _vm._s(
                        _vm.ColumnUtils.resolveColumnLabel(
                          _vm.TYPE_NAMES.basic_data_PaymentType,
                          "code",
                          _vm.billPayment.paymentType,
                          "name"
                        )
                      )
                    )
                  ]),
                  _c(
                    "td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showWhtTax,
                          expression: "showWhtTax"
                        }
                      ],
                      staticClass: "header"
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("FinanceManage.charge_notWhtAmount"))
                      )
                    ]
                  ),
                  _c(
                    "td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showWhtTax,
                          expression: "showWhtTax"
                        }
                      ],
                      staticClass: "values"
                    },
                    [_vm._v(_vm._s(_vm.chargeNotWhtAmount))]
                  )
                ])
              ]
            ),
            !_vm.isApply
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "20px",
                      "margin-bottom": "20px",
                      width: "100%",
                      height: "30px"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { float: "right" },
                        attrs: { type: "primary" },
                        on: { click: _vm.onViewPaymentRequest }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_ViewPaymentRequest"))
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.dashboardUrl && !_vm.isApply
              ? _c(
                  "div",
                  { ref: "iframeWrapper", staticStyle: { height: "400px" } },
                  [
                    _c("iframe", {
                      ref: "dashboardIframe",
                      attrs: {
                        src: _vm.dashboardUrl,
                        frameborder: "0",
                        allowtransparency: "",
                        width: "100%",
                        height: "100%"
                      }
                    })
                  ]
                )
              : _vm._e(),
            !_vm.isApply
              ? _c("div", { staticStyle: { border: "1px solid #E3E3E3" } }, [
                  _c(
                    "div",
                    { staticStyle: { margin: "5px" } },
                    [
                      _c(
                        "el-tabs",
                        {
                          model: {
                            value: _vm.activeName,
                            callback: function($$v) {
                              _vm.activeName = $$v
                            },
                            expression: "activeName"
                          }
                        },
                        [
                          _vm.isApprove
                            ? _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "CargoMsg.Cargo_ApprovalComments"
                                    ),
                                    name: "comments"
                                  }
                                },
                                [
                                  _c("process-content", {
                                    attrs: { form: _vm.form }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "CargoMsg.Cargo_ApprovalCommentsRecord"
                                ),
                                name: "record"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "max-height": "130px",
                                    overflow: "auto"
                                  }
                                },
                                _vm._l(_vm.records, function(record, index) {
                                  return _c(
                                    "div",
                                    { key: index },
                                    [
                                      _c(
                                        "el-card",
                                        { staticClass: "box-card" },
                                        [
                                          record.actionType !== 7000
                                            ? _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex"
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_Approver"
                                                        )
                                                      ) + "： "
                                                    )
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ColumnUtils.resolveColumnLabel(
                                                          _vm.TYPE_NAMES
                                                            .basic_data_User,
                                                          "userId",
                                                          record.userId,
                                                          "chineseName"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_ApprovalComments"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.WorkflowUtil.getActionName(
                                                          record.actionType
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Remarks"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(record.remark)
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_ApprovalTime"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(record.createTime)
                                                    )
                                                  ])
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    display: "flex"
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "CargoMsg.Cargo_Initiator"
                                                        )
                                                      ) + "： "
                                                    )
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.ColumnUtils.resolveColumnLabel(
                                                          _vm.TYPE_NAMES
                                                            .basic_data_User,
                                                          "userId",
                                                          record.userId,
                                                          "chineseName"
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_Remarks"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(record.remark)
                                                    )
                                                  ]),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "30px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_StartTime"
                                                          )
                                                        ) + "： "
                                                      )
                                                    ]
                                                  ),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(record.createTime)
                                                    )
                                                  ])
                                                ]
                                              ),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    record.files &&
                                                    record.files.length > 0,
                                                  expression:
                                                    "record.files && record.files.length > 0"
                                                }
                                              ],
                                              staticStyle: {
                                                "margin-top": "10px",
                                                cursor: "pointer"
                                              }
                                            },
                                            _vm._l(record.files, function(
                                              file,
                                              index
                                            ) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass: "file-style",
                                                  staticStyle: {
                                                    display: "inline-block"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "10px",
                                                        display: "flex"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.downloadFile(
                                                            file.fileId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-paperclip"
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "file-name"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              file.fileName
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            color: "darkgray"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.WorkflowUtil.fileSizeLabel(
                                                                file.fileSize
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm.isApply && _vm.hasBtn
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "10px",
                      "margin-bottom": "10px"
                    }
                  },
                  [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Remarks")) + ":")
                    ]),
                    _c("process-content", { attrs: { form: _vm.form } })
                  ],
                  1
                )
              : _vm._e()
          ]),
          _c("template", { staticStyle: { height: "65px" }, slot: "footer" }, [
            _c("div", { staticStyle: { display: "flex" } }, [
              _vm._v(
                " " + _vm._s(_vm.$t("CargoMsg.Cargo_RefuseAndReturnNode")) + " "
              )
            ]),
            _c(
              "div",
              { staticStyle: { float: "right", display: "flex" } },
              [
                _vm._l(_vm.btnList, function(btn, index) {
                  return _c(
                    "el-button",
                    {
                      key: index,
                      attrs: {
                        title: btn.title,
                        type: btn.color,
                        disabled: btn.preCriteriaState === false
                      },
                      on: {
                        click: function($event) {
                          return _vm.onAction(btn)
                        }
                      }
                    },
                    [_vm._v(_vm._s(btn.actionName))]
                  )
                }),
                _c("el-button", { on: { click: _vm.handleClose } }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
                ])
              ],
              2
            )
          ])
        ],
        2
      ),
      _c("bill-payment-dialog", {
        attrs: {
          visible: _vm.showBillPaymentDialog,
          source: "append",
          "bill-payment-uuid": _vm.billPayment.uuid,
          "show-wht": _vm.showWhtTax
        },
        on: {
          "update:visible": function($event) {
            _vm.showBillPaymentDialog = $event
          },
          cancel: function($event) {
            _vm.showBillPaymentDialog = false
          },
          hiddenDialog: function() {
            _vm.$refs.cargoDialog.minSize = true
          }
        }
      }),
      _vm.chooseUserDialogAdd.visible
        ? _c("choose-user-dialog-add", {
            attrs: {
              title: _vm.$t("CargoMsg.Cargo_SelectSigner"),
              visible: _vm.chooseUserDialogAdd.visible,
              value: _vm.chooseUserDialogAdd.userIds
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chooseUserDialogAdd, "visible", $event)
              },
              close: function($event) {
                _vm.chooseUserDialogAdd.visible = false
              },
              change: _vm.addSignature
            }
          })
        : _vm._e(),
      _vm.chooseUserDialogTransfer.visible
        ? _c("choose-user-dialog-transfer", {
            attrs: {
              title: _vm.$t("CargoMsg.Cargo_SelectTransferor"),
              visible: _vm.chooseUserDialogTransfer.visible,
              value: _vm.chooseUserDialogTransfer.userIds
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chooseUserDialogTransfer, "visible", $event)
              },
              close: function($event) {
                _vm.chooseUserDialogTransfer.visible = false
              },
              change: _vm.transferSignature
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }